'use client';

import Image from 'next/image';
import Link from 'next/link';

import fbIcon from 'public/icons/header-socials-facebook.svg';
import igIcon from 'public/icons/header-socials-ig.svg';
import worldIcon from 'public/icons/world-icon-white.svg';

import styles from './styles.module.scss';

const SocialHeader = () => {
  return (
    <div className={styles.socialHeaderBg}>
      <div className={styles.socialHeaderContainer}>
        <div className={styles.socialLeftBox}>
          <a href="https://www.facebook.com/patynavintage/" target="_blank">
            <Image src={fbIcon} width={16} height={16} alt="Facebook" />
          </a>

          <a href="https://www.instagram.com/patynavintage/" target="_blank">
            <Image src={igIcon} width={16} height={16} alt="Facebook" />
          </a>
        </div>

        <div className={styles.socialRightBox}>
          <Link href="/foreign-customers">
            <Image src={worldIcon} width={16} height={16} alt="Ikona świata" />
            <p>Foreign customers</p>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SocialHeader;
